import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import {isEmpty} from "lodash";

export class BackupAndRestoreBpmnBeforeApproval implements CommandHandler {

  private backupTrackingChangesMap: Map<string, Array<string>> = new Map<string, Array<string>>();

  constructor(private bpmnExtensionHelper: BpmnExtensionHelper, private elementRegistry) {
  }

  postExecute(context): any {
    if (context.backupTrackingChanges) {
      this.backupTrackingChangesMap = context.backupTrackingChanges;
      return;
    }
    if (context.restoreTrackingChanges && !isEmpty(this.backupTrackingChangesMap)) {
      this.restoreTrackingChangesData();
      this.backupTrackingChangesMap = new Map<string, Array<string>>();
      return;
    }
  }

  private restoreTrackingChangesData() {
    this.backupTrackingChangesMap.forEach((nodeIDs: Array<string>, trackingChangeType: string) => {
      nodeIDs.forEach((nodeID) => {
        const element = this.elementRegistry.get(nodeID);
        if (element) {
          this.bpmnExtensionHelper.markElementForChange(element, trackingChangeType);
        }
      })
    })


  }


}
